export enum PaymentError {
  PAYMENT_INFO_NOT_SET = 'PAYMENT_INFO_NOT_SET',
  RAPIDPAY_SDK_FAILURE = 'RAPIDPAY_SDK_FAILURE',
  COULD_NOT_GET_DELEGO_TOKEN = 'COULD_NOT_GET_DELEGO_TOKEN',
  COULD_NOT_GET_MERCHANT_ID = 'COULD_NOT_GET_MERCHANT_ID',
  PAYMENT_ERROR_RESPONSE = 'PAYMENT_ERROR_RESPONSE',
  SAVING_LOGS_ERROR = 'SAVING_LOGS_ERROR',
  CC_LIMIT_EXCEEDED = 'CC_LIMIT_EXCEEDED',
  THREEDS_ERROR = 'THREEDS_ERROR',
  NON_ZERO_GROSS_VALUE_NO_CALCULATION_BREAKDOWN = 'NON_ZERO_GROSS_VALUE_NO_CALCULATION_BREAKDOWN',
}
